import axios from "axios";
import { getLocale, getToken } from '../utils/common';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: false,
  timeout: 100000,
  headers: {
    Accept: "application/json, text/plain, */*",
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
    "Accept-language": getLocale(),
    "locale": getLocale()
  }
});


apiClient.interceptors.request.use(request => {
  // Edit request config
  request.headers = {
    ...request.headers,
    Accept: "application/json, text/plain, */*",
    Authorization: `Bearer ${getToken()}`,
    // authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
    "Accept-language": getLocale(),
    "locale": getLocale()
  };
  return request;
}, error => {
  return Promise.reject(error);
});

// axios.interceptors.request.use(
//   async (config) => {
//     const token = getToken()

//     if (token) {
//       config.headers = {
//         ...config.headers,
//         Accept: "application/json, text/plain, */*",
//         Authorization: `Bearer ${getToken()}`,
//         authorization: `Bearer ${getToken()}`,
//         "Content-Type": "application/json",
//         "Accept-language": getLocale(),
//         "locale": getLocale()
//       };
//     }

//     return config;
//   },
//   (error) => Promise.reject(error)
// );


// axios.interceptors.request.use(
//   function (config) {
//     config.headers = { 
//       Accept: "application/json, text/plain, */*",
//       Authorization: `Bearer ${getToken()}`,
//       "Content-Type": "application/json",
//       "Accept-language": getLocale(),
//       "locale": getLocale()
//     }
//     return config;
//   },
//   (err) => {
//     return Promise.reject(err);
//   }
// );

// axios.interceptors.response.use((response) => {
//   if(response.status === 401) {
//        alert("You are not authorized");
//   }
//   return response;
// }, (error) => {
//   if (error.response && error.response.data) {
//       return Promise.reject(error.response.data);
//   }
//   return Promise.reject(error.message);
// });

export default apiClient;